<template>
  <div>
    <div class="margin-bottom" style="display: flex;align-items: center;">
      <div class="h-input-group" v-width="320">
        <DatePicker v-model="params.start" style="width: 140px" :clearable="false" :option="{end:params.end}"
                    format="YYYY-MM-dd"></DatePicker>
        <span class="h-input-addon">至</span>
        <DatePicker v-model="params.end" style="width: 140px" :clearable="false" :option="{start:params.start}"
                    format="YYYY-MM-dd"></DatePicker>
      </div>
      <Select v-model="params.type" :datas="typeDatas" keyName="id" titleName="name"
              style="width: 140px" class="margin-left"></Select>
      <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch" class="margin-left">查询</Button>
      <Button color="green" icon="fa fa-plus" @click="add" class="margin-left">新增单据</Button>
    </div>
    <vxe-table border show-overflow size="mini" highlight-hover-row :loading="loading" :data="orderList">
      <vxe-column type="seq" width="60"></vxe-column>
      <vxe-column field="code" title="单据编号" width="180"></vxe-column>
      <vxe-column field="billDate" title="单据日期" width="120"></vxe-column>
      <vxe-column title="类型" width="120">
        <template #default="{row}">
          {{ typeName(row.type) }}
        </template>
      </vxe-column>
      <vxe-column field="supplierName" title="供货商/客户"></vxe-column>
      <vxe-column field="amount" title="单据金额" width="120" align="right"></vxe-column>
      <vxe-column title="状态" width="120">
        <template #default="{row}">
          <span :class="{'red-color': row.status === 1}">{{ row.status === 2 ? '已生成凭证' : '未生成凭证' }}</span>
        </template>
      </vxe-column>
      <vxe-column title="操作" width="100">
        <template #default="{row}">
          <span class="actions" v-if="row.status !== 2" @click="remove(row)">删除</span>
        </template>
      </vxe-column>
    </vxe-table>
    <Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
                @change="loadList" small align="right"/>

    <Modal v-model="showForm" :closeOnMask="false" hasCloseIcon>
      <div slot="header">新增单据</div>
      <Form ref="form" :labelWidth="100" :model="form" :rules="validationRules">
        <Row type="flex">
          <Cell :flex="1">
            <FormItem label="单据日期" prop="billDate">
              <DatePicker v-model="form.billDate" :clearable="false" format="YYYY-MM-dd"></DatePicker>
            </FormItem>
          </Cell>
          <Cell :flex="1">
            <FormItem label="单据类型" prop="type">
              <Select v-model="form.type" :datas="typeDatas" keyName="id" titleName="name"
                      @change="typeChange"></Select>
            </FormItem>
          </Cell>
        </Row>
        <FormItem label="供货商/客户" prop="supplierId">
          <Select v-model="form.supplierId" :datas="supplierOptions" keyName="id" titleName="name"
                  :filterable="true"></Select>
        </FormItem>
        <FormItem label="单据明细" prop="details">
          <vxe-table border show-overflow size="mini" :data="form.details">
            <vxe-column type="seq" width="50"></vxe-column>
            <vxe-column title="物料" min-width="200">
              <template #default="{row}">
                <Select v-model="row.materielId" :datas="materialList" keyName="id" titleName="name"
                        :filterable="true" style="width: 100%"></Select>
              </template>
            </vxe-column>
            <vxe-column title="数量" width="130">
              <template #default="{row}">
                <NumberInput v-model="row.qty" style="width: 100%"></NumberInput>
              </template>
            </vxe-column>
            <vxe-column title="单价" width="130">
              <template #default="{row}">
                <NumberInput v-model="row.price" style="width: 100%"></NumberInput>
              </template>
            </vxe-column>
            <vxe-column title="金额" width="100" align="right">
              <template #default="{row}">
                {{ rowAmount(row) }}
              </template>
            </vxe-column>
            <vxe-column title="操作" width="60">
              <template #default="{row}">
                <span class="actions" @click="removeDetail(row)">删除</span>
              </template>
            </vxe-column>
          </vxe-table>
          <div class="margin-top">
            <Button size="s" icon="fa fa-plus" @click="addDetail">添加明细</Button>
          </div>
        </FormItem>
      </Form>
      <div class="text-center margin-top">
        <Button color="green" @click="submit" :loading="loading">保存</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import manba from "manba";

/**
 * 单据类型：0 期初入库，1 验收入库单，2 验收退货单，3 报损出库单，6 销售扣减单，7 外销单
 */
const typeDatas = [
  {id: 0, name: '期初入库'},
  {id: 1, name: '验收入库'},
  {id: 2, name: '验收退货'},
  {id: 3, name: '报损出库'},
  {id: 6, name: '销售扣减'},
  {id: 7, name: '外销'}
];

const emptyForm = () => {
  return {
    billDate: manba().format(),
    type: 0,
    supplierId: null,
    details: [{materielId: null, qty: null, price: null}]
  };
};

export default {
  name: "OrderManage",
  data() {
    return {
      typeDatas,
      params: {
        start: manba().startOf(manba.MONTH).format(),
        end: manba().endOf(manba.MONTH).format(),
        type: null
      },
      orderList: [],
      materialList: [],
      supplierList: [],
      form: emptyForm(),
      validationRules: {
        required: ['billDate', 'type', 'supplierId']
      },
      showForm: false,
      loading: false,
      pagination: {
        page: 1,
        size: 20,
        total: 0
      }
    }
  },
  computed: {
    queryParams() {
      return {
        start: this.params.start,
        end: this.params.end,
        type: this.params.type === null ? undefined : this.params.type,
        page: this.pagination.page,
        pageSize: this.pagination.size
      };
    },
    supplierOptions() {
      //6/7 销售/外销使用客户，其他使用供应商
      let isCustomer = this.form.type === 6 || this.form.type === 7;
      return this.supplierList.filter(val => isCustomer ? val.type === 2 : val.type === 1);
    }
  },
  methods: {
    loadList() {
      this.loading = true;
      this.$api.setting.inventoryOrder.list(this.queryParams).then(({data}) => {
        this.orderList = data.results || [];
        this.pagination.total = data.total;
      }).finally(() => this.loading = false);
    },
    doSearch() {
      this.pagination.page = 1;
      this.loadList();
    },
    typeName(type) {
      let t = typeDatas.find(val => val.id === type);
      return t ? t.name : type;
    },
    add() {
      this.form = emptyForm();
      this.showForm = true;
    },
    typeChange() {
      this.form.supplierId = null;
    },
    addDetail() {
      this.form.details.push({materielId: null, qty: null, price: null});
    },
    removeDetail(row) {
      let index = this.form.details.indexOf(row);
      if (index !== -1) {
        this.form.details.splice(index, 1);
      }
    },
    rowAmount(row) {
      return (Number(row.qty || 0) * Number(row.price || 0)).toFixed(2);
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        let details = this.form.details.filter(val => val.materielId);
        if (!details.length) {
          this.$Message.error('请填写单据明细！');
          return;
        }
        let supplier = this.supplierOptions.find(val => val.id === this.form.supplierId);
        let data = {
          billDate: `${manba(this.form.billDate).format('YYYY-MM-DD')} 00:00:00`,
          type: this.form.type,
          supplierId: this.form.supplierId,
          supplierName: supplier ? supplier.name : null,
          details: details.map(val => {
            return {
              materielId: val.materielId,
              qty: val.qty,
              price: val.price,
              amount: this.rowAmount(val)
            };
          })
        };
        this.loading = true;
        this.$api.setting.inventoryOrder.save(data).then(() => {
          this.$Message('保存成功~');
          this.showForm = false;
          this.loadList();
        }).catch(() => {
        }).finally(() => this.loading = false);
      }
    },
    remove(data) {
      this.$Confirm("确认删除该单据?").then(() => {
        this.$api.setting.inventoryOrder.delete(data.id).then(() => {
          this.loadList();
        })
      })
    }
  },
  created() {
    Promise.all([
      this.$api.setting.inventoryMaterial.list(),
      this.$api.setting.inventorySupplier.list()
    ]).then((results) => {
      this.materialList = results[0].data || [];
      this.supplierList = results[1].data || [];
    });
    this.loadList();
  }
}
</script>
